import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useGetPrivacyPolicyUrl } from 'utils/use-get-privacy-policy-url'
import { OneTrustCookieSettingsButtonAsLink } from 'utils/OneTrustCookieSettingsButton'

export const PoliciesMicroLink: React.FC<{}> = () => {
  const { t } = useTranslation()
  const privacyPolicyURL = useGetPrivacyPolicyUrl()

  return (
    <Box sx={{ fontSize: '.8rem', color: 'grey.600', textAlign: 'center' }}>
      <a href={privacyPolicyURL} target='_blank'>
        {t('legal.privacy_settings.microlink_privacy_url')}
      </a>{' '}
      {t('legal.privacy_settings.microlink_and')}{' '}
      <OneTrustCookieSettingsButtonAsLink text={t('legal.privacy_settings.microlink_cookies_url')} />{' '}
      {t('legal.privacy_settings.microlink_policy')}
    </Box>
  )
}
